import { getTermValue } from '@/packages/JsonQuery';
import { EMaxPrepay } from '@/packages/api-models/common/json_query';

import { type ITagGroupConfig } from '../types';

const TEXT_MAP: { [key in EMaxPrepay]: string | null } = {
  [EMaxPrepay.Any]: null,
  [EMaxPrepay.Month]: 'не более месяца',
  [EMaxPrepay.TwoMonths]: 'не более 2 месяцев',
  [EMaxPrepay.ThreeMonths]: 'не более 3 месяцев',
};

export const prepay: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getTermValue('prepay')(jsonQuery);
    if (!value) {
      return null;
    }

    const text = TEXT_MAP[value];
    if (!text) {
      return null;
    }

    return [
      {
        group: 'prepay',
        text: `Предоплата: ${text}`,
      },
    ];
  },
  delete({ onChange }) {
    onChange({
      action: 'setPrepay',
      arguments: [null],
    });
  },
};
